import { atom } from 'recoil';

export const showChoicePopupSearchField = atom({
  key: 'showChoicePopupSearchField',
  default: false,
});
